import { defineStore } from 'pinia'

export default defineStore({
  id: 'notification',
  state: () => {
    return {
      notifications: [] as any[],
      unread: 0
    }
  },
  actions: {
    setNotifications: function (payload: any[]) {
      this.notifications = payload || []
    },
    setUnread: function (payload: number) {
      this.unread = payload || 0
    },
    plusUnread: function (payload: number) {
      this.unread = this.unread + payload
    },
    unshiftNotification: function (payload: any) {
      if (payload) {
        this.notifications.unshift(payload)
      }
    },
    pushNotifications: function (payload: any[]) {
      if (payload && Array.isArray(payload)) {
        this.notifications.push(...payload)
      }
    },
    changeRead: function (payload: string[]) {
      this.notifications.forEach((notification: any, index: number) => {
        if (payload.includes(notification._id)) {
          this.notifications[index].read = true
          this.unread = this.unread - 1
          if (this.unread < 0) {
            this.unread = 0
          }
        }
      })
    },
    changeReadAll: function () {
      this.notifications.forEach((notification: any, index: number) => {
        this.notifications[index].read = true
      })
      this.unread = 0
    },
    clear: function () {
      this.notifications = []
      this.unread = 0
    }
  },
  getters: {
    getNotifications: (state: any) => state.notifications,
    countNotifications: (state: any) => state.notifications.length,
    getUnread: (state: any) => state.unread
  }
})
